<template>
  <!--sqm实验记录-->
  <h-list-page>
    <h-card :title="h_i18n('13fe8d8c74cb94357d8e105686778dfe')" width="100%" footer is-search @change-method="changeMethod">
      <h-area>
        <h-search :title="h_i18n('f1edca9f040d256cee01ef89fa5499f0')">
          <h-autocomplete
              popper-class="planHidden"
              v-model="searchData.patternNo"
              :fetch-suggestions="mtlNoChange"
              :trigger-on-focus="false"
              @input="() =>searchData.patternNo.length < 4? (plan.showMtlPlan = false): ''"
              @clear="plan.showMtlPlan = false"
              clearable
              :placeholder="h_i18n('3bdbd9312d3a6f04ebdb6b99ac0f2f4a')"
              @blur="myBlur('showMtlPlan')"
              @focus="myFocus3('showMtlPlan')"
          >
          </h-autocomplete>
          <h-detail width="400px" top="34px" left="0px">
            <el-table v-show="plan.showMtlPlan" v-loading="loading.mtlLoading" ref="filterTable" :data="mtlNoList" border size="small" max-height="252" @row-click="clickMtlNo" @mousedown="planBlur=true">
              <el-table-column prop="mtlNo" :label="h_i18n('56ca9a2de6d54b00fb98ab39cce17089')" width="120"></el-table-column>
              <el-table-column prop="mtlName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')"></el-table-column>
            </el-table>
          </h-detail>
        </h-search>
        <h-search :title="h_i18n('901fcadda8a5683e7a83a0c811ff4382')">
          <h-input v-model="searchData.patternName" clearable></h-input>
        </h-search>
        <h-search :title="h_i18n('1f73e72960b0286b70d7226116671454')">
          <h-select v-model="searchData.fromLeaderDepartId" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" style="width: 196px" clearable filterable>
            <h-option v-for="(item, index) in sybList" :key="index" :label="item.valueName" :value="item.valueId"></h-option>
          </h-select>
        </h-search>
        <h-search :title="h_i18n('3acaada618a4b8dcf622e25ddec8fa06')">
          <h-input v-model="searchData.testNo" clearable></h-input>
        </h-search>
        <h-search :title="h_i18n('cde16cddb7c94dfa80d78177be8b78a6')">
          <h-select v-model="searchData.finallyResult" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" style="width: 196px" clearable filterable>
            <h-option value="P" :label="h_i18n('86f720320b77bb62311f0a4811db04fe')"></h-option>
            <h-option value="F" :label="h_i18n('6e5a122013138ad189517d5d0a1c0891')"></h-option>
            <h-option value="N/P" label="N/P"></h-option>
            <h-option value="/" label="/"></h-option>
            <h-option value="不判定" :label="h_i18n('37264dde25a744b5d022854bcaf285ee')"></h-option>
            <h-option value="未检测" :label="h_i18n('5c6585e09b0ae14169393efb3bb7c8dd')"></h-option>
            <h-option value="不适用" :label="h_i18n('321ff794aab8c6cd671990a98ef212a0')"></h-option>
          </h-select>
        </h-search>
        <!-- <h-search title="申诉状态">
          <h-select v-model="searchData.appealStatus" placeholder="请选择" style="width: 196px" clearable filterable>
            <h-option value="自动认可" label="自动认可"></h-option>
            <h-option value="供方认可" label="供方认可"></h-option>
            <h-option value="待审核" label="待审核"></h-option>
            <h-option value="待终判" label="待终判"></h-option>
            <h-option value="终判通过" label="终判通过"></h-option>
            <h-option value="终判不通过" label="终判不通过"></h-option>
          </h-select>
        </h-search> -->
        <h-search :title="h_i18n('e82da8a5ed89d557f32a2e784463fcd3')">
          <h-date-picker @change="dateMapChange('One',dateMap.One)" v-model="dateMap.One" type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" clearable/>
        </h-search>
        <h-search :title="h_i18n('7b2180c2843cc93ce48b42ea19dd3704')">
          <h-date-picker @change="dateMapChange('Two',dateMap.Two)" v-model="dateMap.Two" type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" clearable/>
        </h-search>

        <template #operate>
          <h-button type="primary" :loading="loading.table" @click="paginationQuery(1)">
            <template #icon>
              <search/>
            </template>{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</h-button>
        </template>
      </h-area>
    </h-card>
    <div style="position: relative;margin-top: 10px;">
      <h-table-card :title="h_i18n('50bacd17606df81493ad646602c5b0cb')" :is-left="0" :h-data="tableDataList">
        <template #buttonGroup>
          <div style="display: flex">
            <h-button-group>
              <!-- <h-button type="default" v-if="buttonList.includes('DC')" :loading="loading.export" newEx @click="derive">
                导出
                <template #icon>
                  <export/>
                </template>
              </h-button> -->
              <div class="tipBox_yellow">
                <img src="@/assets/img/tips-icon.png" class="tip-img" />
                  {{ h_i18n('A6097BCE7EA82BD1FE61475345862C1A') }}
              </div>
            </h-button-group>
          </div>
        </template>
        <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" v-loading="loading.table" height="500"
                  @selection-change="listCheckBoxChange" border :data="tableDataList" size="small"
                  style="width: 100%;min-height: 500px;">
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column prop="testNo" :label="h_i18n('3acaada618a4b8dcf622e25ddec8fa06')" width="220"></el-table-column>
          <el-table-column prop="finallyResultName" :label="h_i18n('cde16cddb7c94dfa80d78177be8b78a6')" min-width="70"></el-table-column>
          <el-table-column prop="itemNameFail" :label="h_i18n('cd870b08f21b6e8b8d4e5da723e11f63')" min-width="200">
            <template #default="{row}">
              <span v-if="row.finallyResultName == h_i18n('6e5a122013138ad189517d5d0a1c0891')" class="h-global-font--blue" @click="lookDetail(row)">{{ row.itemNameFail }}</span>
              <span v-else>{{ row.itemNameFail }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="patternNo" :label="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" min-width="130"></el-table-column>
          <el-table-column prop="patternName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')" width="200" align="left"></el-table-column>
          <el-table-column prop="supplyCode" :label="h_i18n('1b7ecd2bdbd8a1a112dead57724f06df')" min-width="90"></el-table-column>
          <el-table-column prop="supplyName" :label="h_i18n('9190cc22c9ba377113bc54ac51013a0b')" width="200" align="left"></el-table-column>
          <el-table-column prop="consignDepart" :label="h_i18n('1f73e72960b0286b70d7226116671454')" min-width="120"></el-table-column>
          <el-table-column prop="placeOrderDay" :label="h_i18n('e82da8a5ed89d557f32a2e784463fcd3')" width="100" :formatter="timeFormatter"></el-table-column>
          <el-table-column prop="reportDate" :label="h_i18n('f1f98fb723f1b89ccf690afff7384879')" width="100" :formatter="timeFormatter"></el-table-column>
          <el-table-column prop="patternAmount" :label="h_i18n('bde1a7ef818b4855b99fa5403ac5c5a9')" width="70"></el-table-column>
        </el-table>
        <template #pagination>
          <el-pagination background @current-change="paginationQuery" v-model:current-page="pageNation.pageNo"
                         :page-size="10" layout="total, prev, pager, next,jumper" :total="pageNation.total">
          </el-pagination>
        </template>
      </h-table-card>
    </div>
  </h-list-page>
</template>
<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';


import {DataFormatter, Export, Loading, LoadingButton, Request, Time, Trim} from "../../../Decorator/vue2-decorator";

export default {
  data() {
    return {
      searchData: {
        patternNo: "",
      },
      loading: {
        export: false,
        table: false
      },

      plan: {},
      mtlNoList: [],
      supplyCodeList: [],
      planBlur: false,
      pageNation: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      laboratoryList: [],
      name: "",
      multipleSelection: [],//选中
      tableDataList: [],//列表
      buttonList: [],
      derivePlan: false,
      // materielCategoryNameList: [],
      dateMap: {
        One: "",
        Two: ""
      },
      sybList: [],//事业部，委托试验单位
    }
  },
  computed: {
    clearAble() {
      let list = Object.keys(this.dateMap)

      let a = list.filter(v => {
        return !!this.dateMap[v];
      })
      return a.length > 1;
    }
  },

  methods: {
    h_i18n,
    print() {
      if (this.multipleSelection.length === 0) {
        this.warning(h_i18n('575cc68b43e2cf55d3dfa3cfb9d69455'))
        return
      }
      let url = "https://hmqm.haier.net/newproduct/tag_print?testNo=" + this.multipleSelection.map(v => v.testNo)
      window.open(url)
      // this.$router.push({
      //   name: "LaboratoryCapabilityInspectionExperimentalPrintHMQM",
      //   query: {
      //     list: JSON.stringify(this.multipleSelection.map(v => v.testNo)),
      //     name: this.$route.query.name,
      //     nickName: this.$route.query.nickName
      //   }
      // })
    },
    @Request("vmiServiceBasic")
        @LoadingButton("sync")
        @Loading(h_i18n('4cfd2bc5f1af24041be4353a38295bce'))
    sync() {
      if (this.multipleSelection.length !== 1) {
        this.warning(h_i18n('11dbd900005469b019effdbda3a1b1d9'))
        return;
      }
      let row = this.multipleSelection[0]
      if (row.testAdminAuditSign === "Y" || row.testAdminAuditSign === "2040") {
        this.warning(h_i18n('3c3dd9539f60b11ea09867e74242779d'))
        return;
      }
      return request({
        method: "Get",
        url: "/testTaskReport/synchroTestTaskReport?testNo=" + row.testNo,
      }).then(res => {
        if (res.data.code === "200") {
          this.success({
            title: h_i18n('330363dfc524cff2488f2ebde0500896'),
            message: h_i18n('b82ad5f3315e8b5e62decbd8300dd131'),
            confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
            callback: () => {
              this.paginationQuery(1)
            }
          })
        } else {
          this.error(h_i18n('b438892e9f8ed60dc97b5fc3ae5468db') + res.data.msg)
        }
      }).catch(e => {
        this.error(h_i18n('b438892e9f8ed60dc97b5fc3ae5468db') + e)
      })
    },
    lookOrders() {

      if (this.multipleSelection.length !== 1) {
        this.warning(h_i18n('1de70f0d7e57a72082e5dc6c2bdd59e5'))
        return
      }

      this.$router.push({
        name: "LaboratoryCapabilityInspectionExperimentalOrdersHMQM",
        query: {
          testNo: this.multipleSelection[0].testNo,
          name: this.$route.query.name,
          nickName: this.$route.query.nickName
        }
      })
    },
    /**
     * 获取工厂小微
     */
    getSybList() {
      this.$http({
        method: "get",
         url: "/base/OqcA/listSyb",
      }).then((res) => {
        this.sybList = res.data.map(item=>{
          return {valueName: item.departmentName,valueId: item.departmentId}
        })
      });
      // this.$http({
      //   method: "get",
      //   url: "/unload/baseCommon/listSybInfoByName",
      //   params: {
      //     name: "",
      //   },
      // }).then((res) => {
      //   this.sybList = res.data;
      // });
    },
    // getMtlList() {
    //   this.$http({
    //     method: "get",
    //     url: "/unload/materielCategories/getMaterielCategoryList",
    //   }).then((res) => {
    //     this.materielCategoryNameList = res.data;
    //   });
    // },
    
    lookDetail(row) {
      //跳转HMQM报告明细页
      this.$router.push({
        name: "sqmExperimentRecordDetail",
        query: {
          testNo: row.testNo,
          name: this.$route.query.name,
          nickName: this.$route.query.nickName
        }
      })
    },
    //六位时间格式化函数
    @Time(3, "yyyy-MM-dd")
    timeFormatter(text) {return text},

    changeMethod() {
      this.postThisPageHeight()
    },

    listCheckBoxChange(val) {
      this.multipleSelection = val;
    },

    async init() {
      this.roleCode = this.$route.query.roleCode
      window.getItemName = this.$route.query.name;
      window.getItemNickName = this.$route.query.nickName;
      // await this.paginationQuery(this.pageNation.pageNo)
      // this.getMtlList()
      this.getSybList()
    },


    dateMapChange(item, value) {
      if (value) {
        this.searchData["beginDate" + item] = this.time(value[0], 3)
        this.searchData["endDate" + item] = this.time(value[1], 3)
      } else {
        this.searchData["beginDate" + item] = ""
        this.searchData["endDate" + item] = ""
      }
    },
    paginationQuery(val) {
      this.pageNation.pageNo = val;
      this.searchTableList();
    },

    @LoadingButton("table")
    @Request("vmiServiceBasic")
    searchTableList() {
      return request({
        method: "post",
        url: "/testTaskReport/testTaskReportList",
        data: {
          ...this.pageNation,
          ...this.searchData,
          queryFlag:'sqm',
          "reportSource": 1,
          testAdminAuditSignList:['Y','2040'] // 试验报告的只给供应商展示已经出结论的
        },
      }).then((res) => {
        if (res.data.code === "200") {
          if (res.data.data.records) {
            this.tableDataList = res.data.data.records
            this.pageNation.total = res.data.data.total;
          } else {
            this.tableDataList = [];
            this.pageNation.total = 0;
          }
        } else {
          this.tableDataList = [];
          this.pageNation.total = 0;
        }
      }).catch((err) => {
        this.error(h_i18n('0d66ed02d74d0bd89431d6d59533ffb3') + err)
      });
    },
    /**
     * 处理两个查询
     * *******************************************************************************
     */
     myBlur(v) {
      if (!this.planBlur) {
        this.plan[v] = false;
      }
    },
    myFocus3(v) {
      this.planBlur = false
      if (this.searchData.patternNo.length >= 4) {
        this.plan[v] = true;
      }
    },
    /**
     * 专用号模糊查询
     */
        @Request("vmiService")
    mtlNoChange() {
      this.planBlur = false;
      if (this.searchData.patternNo.length < 4) {
        this.plan.showMtlPlan = false;
      } else {
        this.loading.mtlLoading = true;
        this.plan.showMtlPlan = true;
        return request({
          method: "POST",
          url: "/basicData/searchMaterielList",
          headers: {"content-type": "application/json"},
          data: {
            mtlNo: this.searchData.patternNo,
          },
        }).then((res) => {
          this.mtlNoList = res.data.data;
          this.loading.mtlLoading = false;
        }).catch(e => {
        });
      }
    },
    clickMtlNo(row) {
      this.searchData.patternNo = row.mtlNo;
      this.plan.showMtlPlan = false;
    },
    clickSupplierCode(row) {
      this.planBlur = true;
      this.searchData.supplyCode = row.supplyCode;
      this.plan.showSupplyPlan = false;
    },
    /**
     * 处理两个查询结束
     * *******************************************************************************
     */
  },

  

  mounted() {
    if(!this.$route.query.supplyCode){
      this.info(h_i18n('beb44b5db841f29c9c300f23230b4bef'))
      return
    }
    this.searchData.supplyCode = this.$route.query.supplyCode
    this.init()
  },
  activated() {
    this.postThisPageHeight()
  }
};
</script>
<style lang="scss">
.planHidden {
  display: none;
}
</style>
